import i18next from "i18next";
import translations from "../translations.json";
i18next.init({
    lng: "en",
    lowerCaseLng: true,
    initImmediate: true,
    resources: {
        en: {
            translation: translations,
        },
    },
});
export function translate(key, values) {
    return i18next.t(key, values);
}
//# sourceMappingURL=translate.js.map